import { render, staticRenderFns } from "./BaseButtonService.vue?vue&type=template&id=65ffbddb"
import script from "./BaseButtonService.vue?vue&type=script&lang=js"
export * from "./BaseButtonService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports